<template>

    <div class="vx-row">
        <div class="vx-col w-full mb-3">
            <vx-card title="Utilization" id="utilizationCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[utilizationRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="utilizationRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="utilizationRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="utilizationRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="utilizationRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="utilizationRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadUtilizationData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="utilizationChartOptions" type="line" height="350" :options="utilizationChartOptions" :series="utilizationData"/>

            </vx-card>
        </div>

        <div class="vx-col w-full mb-3">
            <vx-card title="Memory" id="memoryCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[memoryRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="memoryRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadMemoryData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="memoryChartOptions" type="line" height="350" :options="memoryChartOptions" :series="memoryData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-3">
            <vx-card title="GPU Temperature" id="gpuTempCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[gpuTempRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="gpuTempRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="gpuTempRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="gpuTempRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="gpuTempRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="gpuTempRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadGPUTempData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="gpuTempChartOptions" type="line" height="350" :options="gpuTempChartOptions" :series="gpuTempData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-3">
            <vx-card title="Power draw" id="powerDrawCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[powerDrawRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="powerDrawRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="powerDrawRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="powerDrawRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="powerDrawRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="powerDrawRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadPowerDrawData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="powerDrawChartOptions" type="line" height="350" :options="powerDrawChartOptions" :series="powerDrawData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-3">
            <vx-card title="Fan speed" id="fanSpeedCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[fanSpeedRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="fanSpeedRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="fanSpeedRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="fanSpeedRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="fanSpeedRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="fanSpeedRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadFanSpeedData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="fanSpeedChartOptions" type="line" height="350" :options="fanSpeedChartOptions" :series="fanSpeedData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-3">
            <vx-card title="Encoder/Decoder Clock" id="encDecClockCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[encoderDecoderClockRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="encoderDecoderClockRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="encoderDecoderClockRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="encoderDecoderClockRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="encoderDecoderClockRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="encoderDecoderClockRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadEncDecClockData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="encoderDecoderChartOptions" type="line" height="350" :options="encoderDecoderChartOptions" :series="encoderDecoderClockData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-3">
            <vx-card title="GPU Clock" id="gpuClockCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[graphicsClockRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="graphicsClockRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="graphicsClockRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="graphicsClockRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="graphicsClockRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="graphicsClockRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadGraphicsClockData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="graphicsClockChartOptions" type="line" height="350" :options="graphicsClockChartOptions" :series="graphicsClockData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-3">
            <vx-card title="Memory Clock" id="memoryClockCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[memoryClockRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="memoryClockRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryClockRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryClockRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryClockRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="memoryClockRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadMemoryClockData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="memoryClockChartOptions" type="line" height="350" :options="memoryClockChartOptions" :series="memoryClockData"/>

            </vx-card>
        </div>

        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full mb-3">
            <vx-card title="Streaming Multiprocessor clock" id="smClockCard" class="vs-con-loading__container">

                <template slot="actions">
                    <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                        <small class="flex cursor-pointer">
                            <span>{{metricTimes[smClockRange]}}</span>
                            <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                        </small>
                        <vs-dropdown-menu class="w-48">
                            <vs-dropdown-item @click="smClockRange = 1">Last hour</vs-dropdown-item>
                            <vs-dropdown-item @click="smClockRange = 6">Last 6 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="smClockRange = 12">Last 12 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="smClockRange = 24">Last 24 hours</vs-dropdown-item>
                            <vs-dropdown-item @click="smClockRange = 167">Last 7 days</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <feather-icon icon="RefreshCwIcon" @click="loadSmClockData()"></feather-icon>
                </template>

                <vue-apex-charts v-if="smClockChartOptions" type="line" height="350" :options="smClockChartOptions" :series="smClockData"/>

            </vx-card>
        </div>

    </div>

</template>
<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            VueApexCharts
        },
        data() {
            return {

                utilizationData: [{ name: 'test', data: [] }],
                encoderDecoderClockData: [],
                fanSpeedData: [],
                memoryData: [],
                gpuTempData: [],
                graphicsClockData: [],
                memoryClockData: [],
                powerDrawData: [],
                smClockData: [],

                utilizationRange: 1,
                encoderDecoderClockRange: 1,
                fanSpeedRange: 1,
                memoryRange: 1,
                gpuTempRange: 1,
                graphicsClockRange: 1,
                memoryClockRange: 1,
                powerDrawRange: 1,
                smClockRange: 1,

                metricTimes: {
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    167: 'Last 7 days'

                },

                utilizationChartOptions: null,
                encoderDecoderChartOptions: null,
                fanSpeedChartOptions: null,
                memoryChartOptions: null,
                gpuTempChartOptions: null,
                graphicsClockChartOptions: null,
                memoryClockChartOptions: null,
                powerDrawChartOptions: null,
                smClockChartOptions: null
            }
        },
        methods: {
            loadData() {
                this.utilizationChartOptions = this.getMetricsChartOptions('Utilization', ['#7367F0', '#28C76F', '#EA5455', '#FF9F43'])
                this.encoderDecoderChartOptions = this.getMetricsChartOptions('Encoder/decoder clock', ['#7367F0'])
                this.fanSpeedChartOptions = this.getMetricsChartOptions('Fan speed', ['#7367F0'])
                this.memoryChartOptions = this.getMetricsChartOptions('Memory', ['#7367F0', '#EA5455', '#28C76F'])
                this.gpuTempChartOptions = this.getMetricsChartOptions('GPU Temp', ['#7367F0'])
                this.graphicsClockChartOptions = this.getMetricsChartOptions('Graphics clock', ['#7367F0'])
                this.memoryClockChartOptions = this.getMetricsChartOptions('Memory clock', ['#7367F0'])
                this.powerDrawChartOptions = this.getMetricsChartOptions('Power draw', ['#7367F0'])
                this.smClockChartOptions = this.getMetricsChartOptions('Streaming multiprocessor clock', ['#7367F0'])

                this.loadUtilizationData()
                this.loadEncDecClockData()
                this.loadFanSpeedData()
                this.loadMemoryData()
                this.loadGPUTempData()
                this.loadGraphicsClockData()
                this.loadMemoryClockData()
                this.loadPowerDrawData()
                this.loadSmClockData()
            },
            loadUtilizationData() {
                this.loadDataToObject('utilization', this.utilizationRange, 'utilizationData', '#utilizationCard', '')
            },
            loadEncDecClockData() {
                this.loadDataToObject('encoder_decoder_clock', this.encoderDecoderClockRange, 'encoderDecoderClockData', '#encDecClockCard', 'Encoder/Decoder clock')
            },
            loadFanSpeedData() {
                this.loadDataToObject('fan_speed', this.fanSpeedRange, 'fanSpeedData', '#fanSpeedCard', 'Fan speed')
            },
            loadMemoryData() {
                this.loadDataToObject('memory', this.memoryRange, 'memoryData', '#memoryCard', '')
            },
            loadGPUTempData() {
                this.loadDataToObject('gpu_temp', this.gpuTempRange, 'gpuTempData', '#gpuTempCard', 'GPU Temp')
            },
            loadGraphicsClockData() {
                this.loadDataToObject('graphics_clock', this.graphicsClockRange, 'graphicsClockData', '#gpuClockCard', 'Graphics clock')
            },
            loadMemoryClockData() {
                this.loadDataToObject('memory_clock', this.memoryClockRange, 'memoryClockData', '#memoryClockCard', 'Memory clock')
            },
            loadPowerDrawData() {
                this.loadDataToObject('power_draw', this.powerDrawRange, 'powerDrawData', '#powerDrawCard', 'Power draw')
            },
            loadSmClockData() {
                this.loadDataToObject('streaming_multiprocessor_clock', this.smClockRange, 'smClockData', '#smClockCard', 'Streaming multiprocessor clock')
            },
            loadDataToObject(metric, time, objectName, loaderElement, name) {
                this.$vs.loading({
                    container: loaderElement,
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/gpu/' + this.$route.params.id + '/metrics/' + time + '/' + metric)
                loadPromise.then(function(response) {
                    if (name.length !== 0) {
                        thisIns[objectName] = [{ name: name, data: JSON.parse(JSON.stringify(response.data)) }]
                    } else {
                        thisIns[objectName] = JSON.parse(JSON.stringify(response.data))
                    }
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close(loaderElement + ' > .con-vs-loading')
                })
            },
            getMetricsChartOptions(title, colors) {
                return {
                    colors: colors,
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: title,
                        align: 'left'
                    }
                }
            }
        },
        watch: {
            utilizationRange() {
                this.loadUtilizationData()
            },
            encoderDecoderClockRange() {
                this.loadEncDecClockData()
            },
            fanSpeedRange() {
                this.loadFanSpeedData()
            },
            memoryRange() {
                this.loadMemoryData()
            },
            gpuTempRange() {
                this.loadGPUTempData()
            },
            graphicsClockRange() {
                this.loadGraphicsClockData()
            },
            memoryClockRange() {
                this.loadMemoryClockData()
            },
            powerDrawRange() {
                this.loadPowerDrawData()
            },
            smClockRange() {
                this.loadSmClockData()
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
